import { render, staticRenderFns } from "./GoogleReviews.vue?vue&type=template&id=766c7cc4&scoped=true"
import script from "./GoogleReviews.vue?vue&type=script&lang=js"
export * from "./GoogleReviews.vue?vue&type=script&lang=js"
import style0 from "./GoogleReviews.vue?vue&type=style&index=0&id=766c7cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766c7cc4",
  null
  
)

export default component.exports